import moment from "moment";
import { formatMoney } from "../../features/utils/formatMoney";
import { getSupplierName } from "../flight/supplier/getSupplierName";
import { getSupplierClass } from "../../components/flight/FlightOfferDisplay";
import { flightStatusMap } from "../../pages/Orders/OrdersData";
import { alertType } from "../constants";
import Icon from "../../components/HOC/Icon";
import { Link } from "react-router-dom";
import { getStatusName } from "../flight/order/getStatusName";
import { getFlightFareTypeTagElement } from "./flightFareTypeTag";

function getFreezeStatusStyles(status) {
  const normalized = String(status || "").toUpperCase();

  switch (normalized) {
    case "INITIATED":
      return {
        label: "Initiated",
        className: "bg-sky-50 text-sky-700 border-sky-200",
        icon: "mdi:snowflake",
      };
    case "APPROVED":
      return {
        label: "Approved",
        className: "bg-indigo-50 text-indigo-700 border-indigo-200",
        icon: "mdi:check-decagram",
      };
    case "DECLINED":
      return {
        label: "Declined",
        className: "bg-rose-50 text-rose-700 border-rose-200",
        icon: "mdi:close-circle-outline",
      };
    default:
      return {
        label: status || "-",
        className: "bg-slate-50 text-slate-700 border-slate-200",
        icon: "mdi:snowflake-alert",
      };
  }
}

function getFlightOrderDisplayStatus(flightData, priceFreezeId) {
  const mappedStatus = flightStatusMap(flightData?.status);
  const isNotPaid =
    mappedStatus === "Not Paid" ||
    flightData?.status?.toLowerCase() === "booked";

  if (priceFreezeId && isNotPaid) {
    return "Awaiting freeze approval";
  }

  return getStatusName(mappedStatus);
}

export function templateFlightOrderData(data) {
  // console.log(data);
  const flightData = data?.flightBooking?.at(-1);
  const priceFreezeId = flightData?.priceFreezeId;
  const priceFreezeStatus = flightData?.priceFreezeStatus;

  // debugger
  let flightType = "One Way";
  if (flightData?.destinations?.length) {
    flightType = "Multi City";
    if (
      flightData?.destinations?.at(-1)?.to ===
      flightData?.destinations?.at(0)?.from
    )
      flightType = "Return";
  }

  return [
    {
      elements: [
        {
          type: "title",
          value: moment(data?.createdAt)?.format("DD-MM-YYYY HH:mm [GMT]Z"),
        },
        {
          type: "copy",
          value: flightData?.bookingId || flightData?.orderId,
          renderValue: () => (
            <span className="flex gap-2 items-center ">
              <Link
                target="_blank"
                to={"/order/flight/ticket/detail/" + data?._id}
              >
                {flightData?.bookingId || flightData?.orderId}
              </Link>
              <Icon icon="tabler:copy" className="!w-4 !h-4" />
            </span>
          ),
        },
        {
          type: "tag",
          value: getSupplierName(flightData?.supplier),
          className: getSupplierClass(flightData?.supplier),
          color: "text-[#BD002A]",
          background: "bg-[#BD002A]/20",
        },
        {
          type: "title",
          value: "",
        },
        getFlightFareTypeTagElement(flightData),
        {
          type: "Agent",
          render: () => (
            <div className="py-2">
              <small>
                {(data?.account?.firstName || "") +
                  " " +
                  (data?.account?.lastName || "")}
              </small>
              <div
                className="w-[200px] overflow-hidden whitespace-nowrap text-ellipsis"
                title={data?.account?.detail?.tradingName}
              >
                {data?.account?.detail?.tradingName}
              </div>
            </div>
          ),
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[25%]",
    },
    {
      elements: [
        { type: "title", value: flightType },
        {
          type: "text",
          render: () => (
            <div>
              {flightData?.destinations
                ?.slice(0, 1)
                ?.map((obj) => `${obj?.from} - ${obj?.to}`)
                ?.join(",") || ""}
              <div>
                <span className="text-theme1">{flightData?.pnr}</span>
              </div>
              <small>{flightData?.flights?.at(0)?.airlineName}</small>
            </div>
          ),
        },
      ],
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Travel Time" },
        {
          type: "text",
          value:
            moment(flightData?.flights?.at(0)?.departureDate)?.format(
              "YYYY-MM-DD",
            ) + " ",
        },
        {
          type: "text",
          value: (
            <span className="text-blue-500">
              {flightData?.flights?.at(0)?.departureTime +
                " - " +
                flightData?.flights?.at(0)?.arrivalTime}
            </span>
          ),
        },
      ],
      value: moment(flightData?.flights?.at(0)?.departureDate)?.format(
        "YYYY-MM-DD",
      ),
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Passenger" },
        {
          type: "text",
          value: flightData?.travelers
            ?.map(
              (obj) =>
                `${obj?.firstName} ${obj?.middleName || ""} ${obj?.lastName}`,
            )
            ?.join(", "),
        },
      ],
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Agent Price" },
        { type: "text", value: formatMoney(flightData?.payable) },
        {
          render: () => {
            return (
              <div className="flex flex-col text-xxxs">
                <span className="text-primary/50">Customer Price</span>
                <span>{formatMoney(flightData?.customerPayable)}</span>
              </div>
            );
          },
        },
      ],
      value: flightData?.payable,
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Point Of Sale" },
        {
          render: () => {
            return (
              <div className="flex flex-col capitalize">
                <span>{data?.pointOfSale || "-"}</span>
              </div>
            );
          },
        },
      ],
      value: data?.pointOfSale,
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Status" },
        {
          type: "status",
          value: getFlightOrderDisplayStatus(flightData, priceFreezeId),
          // render: () => {
          //   const status = flightStatusMap(flightData?.status);

          //   return (
          //       <div className={`rounded-md mb-3`}>
          //       <span
          //       className={`${alertType[flightData?.status?.toLowerCase()]} overflow-hidden text-ellipsis text-xs `}
          //       title={status}
          //       >
          //           {getStatusName(status)}
          //       </span>
          //       </div>
          //   )
          // }
        },
        ...(priceFreezeId
          ? [
              {
                render: () => {
                  const freezeStatus = getFreezeStatusStyles(priceFreezeStatus);

                  return (
                    <div className="mb-2 flex flex-col gap-1">
                      <span className="text-sm text-[#6D7C94]">
                        Freeze Status
                      </span>
                      <span
                        className={`inline-flex w-fit items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-semibold ${freezeStatus.className}`}
                      >
                        <Icon
                          icon={freezeStatus.icon}
                          className="!h-3.5 !w-3.5"
                        />
                        {freezeStatus.label}
                      </span>
                    </div>
                  );
                },
              },
            ]
          : []),
        {
          type: "time",
          render: () => {
            const diffInSeconds = moment
              .utc(flightData?.ticketingExpiry)
              .diff(moment.utc(), "seconds");

            // Format the difference in the "5h 10m 5s" format
            const hours = Math.floor(diffInSeconds / 3600);
            const minutes = Math.floor((diffInSeconds % 3600) / 60);
            // const seconds = diffInSeconds % 60;
            const onStage = ["Paid", "Pending", "Pendingpayment"]?.includes(
              flightData?.status,
            );

            return (hours || minutes) > 0 && onStage ? (
              <div
                className="flex gap-1 items-center"
                title="Ticket Expiry Time"
              >
                <Icon icon="mdi:clock-outline" className="!w-4 !h-4" />
                {hours || minutes} {hours ? "Hrs" : "Mins"}
              </div>
            ) : null;
          },
        },
      ],
      value: (function () {
        return [
          "Not Paid",
          "Paid",
          "Expired",
          "Awaiting ticketing",
          "Ticket issued",
          "Denied",
          "Canceled",
          "Cancelation Requested",
          "Ticket Canceled",
        ]?.findIndex((val) => val === flightStatusMap(flightData?.status));
      })(),
      width: "md:w-[15%]",
    },
  ];
}
